import { Component, ChangeDetectorRef,OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Employee } from '../../interfaces/employee.interface'; 
import { EmployeeService } from "../../services/employee";
import { Router } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-edit-employee',
  imports: [ReactiveFormsModule, DatePipe],
  templateUrl: './edit-employee.html',
  styleUrl: './edit-employee.css'
})
export class EditEmployeeComponent implements OnInit {
  employees: Employee[] = [];
  myForm: FormGroup;
  selectedEmployee: Employee = {} as Employee;

   constructor(private employeeService: EmployeeService, 
              private cdr: ChangeDetectorRef,
              private router: Router,
              private fb: FormBuilder) 
              {
                this.myForm = this.fb.group({
                  id: new FormControl(0),
                  fname: new FormControl('',[Validators.required,Validators.maxLength(50)]),
                  lname: new FormControl('',[Validators.required,Validators.maxLength(50)]),
                  employeecode: new FormControl('',[Validators.maxLength(25)]),
                  uploaded: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]) 
                });
              }

  get fname() { return this.myForm.get('fname'); }
  get lname() { return this.myForm.get('lname'); }
  get employeecode() { return this.myForm.get('employeecode'); }
  get uploaded() { return this.myForm.get('uploaded'); }

   async ngOnInit(): Promise<void>
  {

      this.selectedEmployee = this.employeeService.selectedEmployee;

       this.myForm.get('id')?.setValue(this.employeeService.selectedEmployee.id);
        this.myForm.get('fname')?.setValue(this.employeeService.selectedEmployee.fname);
        this.myForm.get('lname')?.setValue(this.employeeService.selectedEmployee.lname);
        this.myForm.get('employeecode')?.setValue(this.employeeService.selectedEmployee.employeecode);
      this.myForm.get('uploaded')?.setValue(this.employeeService.selectedEmployee.uploaded);
  }


  async updateEmployee(): Promise<void> 
  {
    var id = this.myForm.value.id != null ? this.myForm.value.id : 0;
    var fname = this.myForm.value.fname != null ? this.myForm.value.fname.trim() : "";
    var lname = this.myForm.value.lname != null ? this.myForm.value.lname.trim() : "";
    var employeecode = this.myForm.value.employeecode != null ? this.myForm.value.employeecode.trim() : "";
    var uploaded = "0000-00-00";

    if (this.myForm.invalid && this.myForm.touched)
    {
      return;
    }

try
        {
          await this.employeeService.updateEmployee(fname,lname,employeecode,uploaded,id);
          this.cdr.detectChanges();
          this.router.navigateByUrl('employee'); 
        } catch (error) {
          console.error('updateemployee error',error);
        }

    }

  goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('employee');
  }
}
